import { FC, useState } from 'react'

import { SequenceMenu, Button } from '@sequencehq/core-components'

import { ProtectedButton, usePermissions } from 'lib/rbac'
import { ArchiveCustomerMenuItem } from 'Customers/index'
import { useCustomerContext } from 'Customer/hooks/useCustomerContext'
import { EditCustomerForm } from 'Customer/drawers/EditCustomer/EditCustomerForm'
import { ViewCustomerPortalButton } from 'components/ViewCustomerPortalButton/ViewCustomerPortalButton.tsx'

export const HeaderButtons: FC = () => {
  const { customer, customerPortalEnabled, refetchCustomer } =
    useCustomerContext()
  const { can } = usePermissions()
  const [isEditingCustomer, setIsEditingCustomer] = useState(false)

  return (
    <>
      {customerPortalEnabled && (
        <ViewCustomerPortalButton
          path={`/customers/${customer?.id}`}
          isDisabled={Boolean(customer?.archivedAt)}
        />
      )}

      <ProtectedButton permission="org.customer:update">
        <Button
          variant="secondary"
          aria-label="Edit customer"
          onClick={() => setIsEditingCustomer(true)}
          disabled={!!customer?.archivedAt}
          data-testid="edit-customer-button"
        >
          Edit customer
        </Button>
      </ProtectedButton>

      {isEditingCustomer && (
        <EditCustomerForm onClose={() => setIsEditingCustomer(false)} />
      )}

      {can('org.customer:archive') && (
        <SequenceMenu
          data-testid="customer.menu"
          variant="ghost"
          alignment="bottom-right"
          disabled={!!customer?.archivedAt}
          items={[
            ({ setIsOpen }) => (
              <ArchiveCustomerMenuItem
                customerId={customer.id}
                onClose={() => {
                  refetchCustomer()
                  setIsOpen?.(false)
                }}
                disabled={!!customer.archivedAt}
                data-testid="customer.menu.archive"
              />
            )
          ]}
        />
      )}
    </>
  )
}
